import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { CoachMark } from '../../../coachMark'
import { coachMarkRoutes } from '../../../coachMark/constants'
import { selectUserType } from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import { COMPANY_TYPES } from '../../../utils/common'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { PreferenceSetting as PreferenceSettingCommon } from '../../common/preferenceSetting'
import { getDetailPanel, getKeyPanels, saveTemplate } from '../helper'
import {
  applySetting,
  selectCurrentTemplate,
  selectDefaultTemplate,
  selectIsFiinGateTemplate,
  selectIsNotHasChange,
  selectLoading,
  selectPanelById,
  selectPanelId,
  selectTemplateId,
  selectTemplateName,
  selectTemplateSearch,
  selectTemplates,
  selectTotalRecord,
  setIsNotHasChange,
} from '../store/slice'
import {
  deleteTemplatesThunk,
  getDefaultTemplateThunk,
  getTemplateDetailThunk,
  getTemplatesSearchThunk,
  getTemplatesThunk,
  setDefaultTemplateThunk,
  updateTemplateThunk,
} from '../store/thunk'

const PreferenceSetting = ({ setIsShowPreferenceSetting }) => {
  const dispatch = useDispatch()

  const companyType = useSelector(selectCompanyInfo).companyType
  const loadingTemplate = useSelector(selectLoading('template'))
  const loadingDefaultTemplate = useSelector(selectLoading('defaultTemplate'))
  const templates = useSelector(selectTemplates)
  const totalRecord = useSelector(selectTotalRecord)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const templateName = useSelector(selectTemplateName)
  const isFiinGateTemplate = useSelector(selectIsFiinGateTemplate)
  const templateId = useSelector(selectTemplateId)
  const defaultTemplate = useSelector(selectDefaultTemplate)
  const loadingSearch = useSelector(selectLoading('templateSearch'))
  const templateSearch = useSelector(selectTemplateSearch)
  const isNotHasChange = useSelector(selectIsNotHasChange)
  const currentTemplate = useSelector(selectCurrentTemplate)
  const userType = useSelector(selectUserType)

  const callApiTemplates = (param) => {
    dispatch(getTemplatesThunk(param))
  }

  const callApiDefaultTemplate = (param) => {
    dispatch(getDefaultTemplateThunk(param))
  }

  const handleBack = () => {
    setIsShowPreferenceSetting(false)
  }

  const setDefaultTemplate = (data) => {
    dispatch(setDefaultTemplateThunk(data))
  }

  const deleteTemplate = (data) => {
    dispatch(
      deleteTemplatesThunk({
        ...data,
        param: {
          summaryTemplateIds: data.param.ids,
          templateType: data.param.templateType,
          deleteType: data.param.deleteType,
        },
      }),
    )
  }

  const updateTemplate = (data) => {
    dispatch(updateTemplateThunk(data))
  }

  const getPanels = (companyType) => {
    const keysPanel = getKeyPanels(companyType)
    return keysPanel.map((key) => {
      const detailPanel = getDetailPanel(key)
      return {
        key,
        label: detailPanel.label,
        type: detailPanel.type,
      }
    })
  }

  const apply = (data) => {
    dispatch(applySetting(data))
    if (isNotHasChange) {
      dispatch(setIsNotHasChange(data.isNotHasChange))
    }
    handleBack()
  }

  const callApiSearch = (value) => {
    dispatch(getTemplatesSearchThunk(value))
  }

  const getCurrentTemplate = (id) => {
    dispatch(
      getTemplateDetailThunk({
        params: { SummaryTemplateId: id },
        companyType,
        userTypeId: userType.userTypeId,
      }),
    )
  }

  return (
    <CoachMark
      id={coachMarkRoutes['/companyAnalysis/summary?preferenceSetting=true']}
    >
      <PreferenceSettingCommon
        handleBack={handleBack}
        template={{
          callApi: callApiTemplates,
          data: templates,
          loading: loadingTemplate || loadingDefaultTemplate,
          total: totalRecord,
          idKey: 'summaryTemplateId',
          nameKey: 'summaryTemplateName',
          dataKey: 'summaryTemplateData',
          setDefaultTemplate,
          deleteTemplate,
          updateTemplate,
          callApiDefaultTemplate,
          defaultTemplate,
          callApiSearch,
          loadingSearch,
          dataTemplateSearch: [
            {
              templateType: COMPANY_TYPES.CORPORATE,
              title: 'preferenceSetting.CORPORATE',
              data: templateSearch[COMPANY_TYPES.CORPORATE],
            },
            {
              templateType: COMPANY_TYPES.BANK,
              title: 'preferenceSetting.BANK',
              data: templateSearch[COMPANY_TYPES.BANK],
            },
            {
              templateType: COMPANY_TYPES.SECURITIES,
              title: 'preferenceSetting.SERCURITY',
              data: templateSearch[COMPANY_TYPES.SECURITIES],
            },
            {
              templateType: COMPANY_TYPES.NON_BANK,
              title: 'preferenceSetting.NON_BANK',
              data: templateSearch[COMPANY_TYPES.NON_BANK],
            },
            {
              templateType: COMPANY_TYPES.FUNDS,
              title: 'preferenceSetting.FUND',
              data: templateSearch[COMPANY_TYPES.FUNDS],
            },
            {
              templateType: COMPANY_TYPES.INSURANCE,
              title: 'preferenceSetting.INSURANCE',
              data: templateSearch[COMPANY_TYPES.INSURANCE],
            },
          ],
        }}
        detailTemplate={{
          getPanels,
          panelsSelected: panelId.map((id) => panelById[id]),
          templateName,
          templateId,
          isFiinGateTemplate,
          saveTemplate: async (data) => {
            const result = await saveTemplate(data, companyType)
            if (result && data.templateId) {
              dispatch(applySetting(data))
              dispatch(setIsNotHasChange(true))
            }
            return result
          },
          apply,
          path: COMPONENTS.companyAnalysis.components.summary.route,
          getCurrentTemplate,
          currentTemplate,
        }}
      />
    </CoachMark>
  )
}

PreferenceSetting.propTypes = {
  setIsShowPreferenceSetting: PropTypes.func.isRequired,
}

export default PreferenceSetting
